import { ExternalLink } from 'lucide-react';

const legalLinks = [
  { title: 'Ad Terms & Definitions', href: '/legal/ad-terms-definitions' },
  { title: 'Ads Policy', href: '/legal/ads-policy' },
  { title: 'Advertising Data Terms', href: '/legal/advertising-data-terms' },
  {
    title: 'Advertising Terms of Service',
    href: '/legal/advertising-terms-of-service',
  },
  { title: 'Business Page Policy', href: '/legal/business-page-policy' },
  { title: 'Business Services Terms', href: '/legal/business-services-terms' },
  { title: 'Community Guidelines', href: '/guidelines/forums' },
  { title: 'Cookies Policy', href: '/cookies-policy' },
  { title: 'Marketplace Guidelines', href: '/guidelines/marketplace' },
  { title: 'Member Agreement', href: '/member-agreement' },
  { title: 'Privacy Policy', href: '/privacy-policy' },
  { title: 'Your Privacy Choices', href: '/your-privacy-choices' },
];

interface LegalLinksProps {
  searchQuery?: string;
}

export function LegalLinks({ searchQuery = '' }: LegalLinksProps) {
  const query = searchQuery.toLowerCase().trim();
  const filteredLinks = query
    ? legalLinks.filter((link) => link.title.toLowerCase().includes(query))
    : legalLinks;

  if (query && filteredLinks.length === 0) {
    return null;
  }

  return (
    <section>
      <h2 className="font-merriweather mb-3 border-b-2 border-[#cdc4c1] pb-2 text-xl font-bold text-[#3D2817] md:text-2xl">
        Legal &amp; Policies
      </h2>
      <ul className="divide-y divide-[#C9BDB0]">
        {filteredLinks.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between py-4 rounded-md focus-visible:outline-2 focus-visible:outline-primary"
            >
              <span className="text-[#3D2817] text-base font-semibold font-merriweather group-hover:text-[#6B5647] transition-colors">
                {link.title}
              </span>
              <ExternalLink className="w-4 h-4 text-[#948780] group-hover:text-[#6B5647] transition-colors shrink-0" aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
